define("shared/components/shared/choose-your-upgrade", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "later/utils/upgrade/choose-your-upgrade", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _chooseYourUpgrade, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"later/utils/upgrade/choose-your-upgrade",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @close={{@closeModal}} class="qa--branding_options_modal" data-test-id="choose-your-upgrade" as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{this.upgradeFeature.title}} class="qa--branding_options_header_txt" />
  
      <modal.card-body class="u--p__t__0">
        <div class="cCU--upgradeCardWrapper">
          {{#each this.upgradeFeature.upgradeOptions as |upgradeOption|}}
            <Shared::ChooseYourUpgrade::PlanCard
              @isSelected={{eq upgradeOption.upgradeFeature this.selectedUpgradeFeatureName}}
              @planDetails={{upgradeOption}}
              @setSelectedUpgradeFeature={{this.setSelectedUpgradeFeature}}
            />
          {{/each}}
        </div>
  
      </modal.card-body>
  
      <modal.card-footer>
        <Shared::Ui::Button
          @onClick={{@closeModal}}
          @text={{t "shared_words.close"}}
          @variant="mute"
          class="u--float--left qa--close_btn"
          data-test-id="choose-your-upgrade-close-button"
        />
        <Shared::Button::Upgrade
          @feature={{this.selectedUpgradeFeature.upgradeFeature}}
          @location={{this.selectedUpgradeFeature.location}}
          @seamlessCheckoutSuccessCallback={{@closeModal}}
          @track={{this.trackUpgrade}}
          as |upgradeAction|
        >
          <Shared::Ui::Button
            @onClick={{upgradeAction}}
            @text={{this.upgradeButtonText}}
            @variant="proceed"
            class="u--float--right qa--upgrade_plan_btn"
          />
        </Shared::Button::Upgrade>
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "WrduSBv7",
    "block": "[[[8,[39,0],[[24,0,\"qa--branding_options_modal\"],[24,\"data-test-id\",\"choose-your-upgrade\"]],[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],[[24,0,\"qa--branding_options_header_txt\"]],[[\"@title\"],[[30,0,[\"upgradeFeature\",\"title\"]]]],null],[1,\"\\n\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"cCU--upgradeCardWrapper\"],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,0,[\"upgradeFeature\",\"upgradeOptions\"]]],null]],null],null,[[[1,\"          \"],[8,[39,3],null,[[\"@isSelected\",\"@planDetails\",\"@setSelectedUpgradeFeature\"],[[28,[37,4],[[30,3,[\"upgradeFeature\"]],[30,0,[\"selectedUpgradeFeatureName\"]]],null],[30,3],[30,0,[\"setSelectedUpgradeFeature\"]]]],null],[1,\"\\n\"]],[3]],null],[1,\"      \"],[13],[1,\"\\n\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,5],[[24,0,\"u--float--left qa--close_btn\"],[24,\"data-test-id\",\"choose-your-upgrade-close-button\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,1],[28,[37,6],[\"shared_words.close\"],null],\"mute\"]],null],[1,\"\\n      \"],[8,[39,7],null,[[\"@feature\",\"@location\",\"@seamlessCheckoutSuccessCallback\",\"@track\"],[[30,0,[\"selectedUpgradeFeature\",\"upgradeFeature\"]],[30,0,[\"selectedUpgradeFeature\",\"location\"]],[30,1],[30,0,[\"trackUpgrade\"]]]],[[\"default\"],[[[[1,\"\\n        \"],[8,[39,5],[[24,0,\"u--float--right qa--upgrade_plan_btn\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,4],[30,0,[\"upgradeButtonText\"]],\"proceed\"]],null],[1,\"\\n      \"]],[4]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@closeModal\",\"modal\",\"upgradeOption\",\"upgradeAction\"],false,[\"shared/modal\",\"each\",\"-track-array\",\"shared/choose-your-upgrade/plan-card\",\"eq\",\"shared/ui/button\",\"t\",\"shared/button/upgrade\"]]",
    "moduleName": "shared/components/shared/choose-your-upgrade.hbs",
    "isStrictMode": false
  });
  let ChooseYourUpgradeComponent = _exports.default = (_class = class ChooseYourUpgradeComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "segment", _descriptor3, this);
      _initializerDefineProperty(this, "selectedUpgradeFeatureName", _descriptor4, this);
      this.selectedUpgradeFeatureName = this.defaultUpgradeFeatureName || this.fallbackUpgradeFeature.upgradeFeature;
    }
    get canTrialPlan() {
      return Boolean(this.auth.currentAccount?.canTrialPlan);
    }
    get defaultUpgradeFeatureName() {
      return this.upgradeFeature.upgradeOptions.find(option => option.selectedByDefault)?.upgradeFeature;
    }
    get fallbackUpgradeFeature() {
      return this.upgradeFeature.upgradeOptions[0];
    }
    get selectedUpgradeFeature() {
      return this.upgradeFeature.upgradeOptions.find(option => option.upgradeFeature === this.selectedUpgradeFeatureName) ?? this.fallbackUpgradeFeature;
    }
    get upgradeButtonText() {
      let translationPath = this.canTrialPlan ? 'plans.choose_your_upgrade.button.trial.' : 'plans.choose_your_upgrade.button.upgrade.';
      translationPath += this.selectedUpgradeFeature.planName;
      return this.intl.t(translationPath);
    }
    get upgradeFeature() {
      return (0, _chooseYourUpgrade.upgradeFeatures)(this.intl)[this.args.upgradeFeatureName];
    }
    setSelectedUpgradeFeature(featureName) {
      this.selectedUpgradeFeatureName = featureName;
    }
    trackUpgrade() {
      if (this.selectedUpgradeFeature?.location) {
        this.segment.track('clicked-upgrade-intent', {
          button_location: this.selectedUpgradeFeature.location,
          ...this.args.segmentPayload
        });
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "selectedUpgradeFeatureName", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "setSelectedUpgradeFeature", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedUpgradeFeature"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackUpgrade", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackUpgrade"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ChooseYourUpgradeComponent);
});